import React from 'react';
import { ReactComponent as Logo } from '../../../../assets/svg/logo-2.svg';
import { useAppSelector } from '../../../../hooks/store';
import { getUniversity } from '../../../../redux/selectors';
export var AuthUniInfo = function () {
    var university = useAppSelector(getUniversity);
    return (React.createElement("div", { className: 'bg-ghost-white rounded p-6 grid' },
        React.createElement("p", { className: 'text-xl font-semibold mb-20' }, university.name),
        React.createElement("p", { className: 'text-4xl font-semibold mb-7' }, "Welcome to community space"),
        React.createElement("p", { className: 'text-reading-lg mb-24 ' }, "Your space to connect and explore what the university has to offer. "),
        React.createElement(Logo, { className: 'self-end' })));
};
